import React from "react";
import { Typography, TextField, Slider, Grid } from "@mui/material";
import { HiOutlineCreditCard, HiOutlineReceiptPercent } from "react-icons/hi2";
import FormDialog, {
  SectionCard,
  PlainCard,
} from "../../../../components/FormDialog";

const EPaymentFeesDialog = ({
  open,
  onClose,
  onSubmit,
  ePaymentFeesData,
  setEPaymentFeesData,
}) => {
  return (
    <FormDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      icon={<HiOutlineCreditCard />}
      title="تحديث عمولة الدفع الإلكتروني"
      subtitle="حدد نسبة العمولة الجديدة ثم احفظ التغييرات"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
      saveText="تحديث"
    >
      <SectionCard icon={<HiOutlineReceiptPercent />} title="العمولة">
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            النقطة: {ePaymentFeesData.name}
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            العمولة الحالية: {(ePaymentFeesData.e_payment_fees * 100).toFixed(1)}%
          </Typography>
          <Slider
            value={(ePaymentFeesData.e_payment_fees * 100).toFixed(1)}
            onChange={(event, newValue) => {
              setEPaymentFeesData({
                ...ePaymentFeesData,
                e_payment_fees: newValue / 100,
              });
            }}
            min={0}
            max={2}
            step={0.1}
            valueLabelDisplay="on"
            valueLabelFormat={(value) => `${value}%`}
            sx={{ mt: 2, mb: 2 }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            type="number"
            label="عمولة الدفع الإلكتروني (%)"
            value={(ePaymentFeesData.e_payment_fees * 100).toFixed(1)}
            onChange={(e) => {
              const value = Math.max(
                0,
                Math.min(2, parseFloat(e.target.value) || 0)
              );
              setEPaymentFeesData({
                ...ePaymentFeesData,
                e_payment_fees: value / 100,
              });
            }}
            inputProps={{ min: 0, max: 2, step: 0.1 }}
            fullWidth
          />
        </Grid>
      </SectionCard>
      <PlainCard>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          <strong>أمثلة:</strong>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          • 1% = 0.01 (الافتراضي)
        </Typography>
        <Typography variant="body2" color="text.secondary">
          • 1.5% = 0.015
        </Typography>
        <Typography variant="body2" color="text.secondary">
          • 2% = 0.02 (الحد الأقصى)
        </Typography>
        <Typography
          variant="body2"
          color="primary"
          sx={{ mt: 2, fontWeight: "bold" }}
        >
          <strong>مثال حي:</strong> معاملة بقيمة 10,000 {`=>`} العمولة ={" "}
          {(ePaymentFeesData.e_payment_fees * 10000).toFixed(0)}
        </Typography>
      </PlainCard>
    </FormDialog>
  );
};

export default EPaymentFeesDialog;
